const invertedMessages = {
  'Refresh progress data': 'certs.refresh.progress',
  'Hide progress details': 'certs.progress.hide',
  '{percentage}% reviewed. Show progress details':
    'certs.progress.show.details',
};

export default invertedMessages;
